import { render } from "./Header.vue?vue&type=template&id=1fba3209&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=1fba3209&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1fba3209"

export default script